import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const currentPath = location.pathname;

  const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/aboutus', label: 'About' },
    { to: '/services', label: 'Amenities' },
    { to: '/#gallery', label: 'Gallery' },
    { to: '/contact', label: 'Contact' },
    { to: '/partnership', label: 'Partner with us' },
  ];

  const isWhiteTextPage = ["/", "/blog", "/partnership", "/terms-of-use"].includes(currentPath);
  const textColorClass = isWhiteTextPage ? "text-white" : "text-black";
  const bgClass = isWhiteTextPage
  ? "absolute top-0 left-0 w-full z-50 bg-transparent"
  : "bg-white";


  return (
    <nav className={`w-full flex justify-center lg:px-[106px] md:px-[64px] px-4 transition-colors duration-300 ${bgClass}`}>
      <div className="lg:h-[120px] w-full sm:h-[40px] md:w-[706px] md:h-[100px] lg:w-[1300px] py-4 flex justify-between items-center">
        
       <Link to="/" className={` ${textColorClass} flex flex-row items-center whitespace-nowrap`}>
         <img src="/Asset-2.png" alt="Znorm Homes Logo" className="w-[55px] h-[55px] md:w-[65px] md:h-[65px] lg:w-[80px] lg:h-[80px] mr-6 object-contain" />
         <div>
           <span className="outfit-title text-[18px] sm:text-[20px] md:text-[24px] lg:text-[30px] font-bold">ZNORM  </span>
           <span className="text-[16px] sm:text-[18px] md:text-[22px] lg:text-[30px] font-light"> HOMES</span>
         </div>
       </Link>


        {/* Desktop Menu */}
        <div className="hidden lg:flex space-x-6 items-center outfit-text h-[48px]">
          {navLinks.map(({ to, label }) => (
            <div key={label} className="flex flex-col items-center">
              <Link
                to={to}
                className={`${textColorClass} hover:text-gray-300 transition duration-300`}
              >
                {label}
              </Link>
              <div
                className={`mt-1 w-[34px] h-[2px] transition-all duration-300 ${
                  currentPath === to ? "bg-[#87A768]" : "bg-transparent"
                }`}
              />
            </div>
          ))}

          <div className={`h-[48px] w-[1px] ${isWhiteTextPage ? "bg-white" : "bg-[#87A768]"} opacity-70 transition duration-300`} />

          <Link
            to="/"
            className="md:w-[148px] md:h-[48px] bg-[#87A768] hover:brightness-105 text-white text-[12px] md:text-[14px] lg:text-[16px] font-outfit transition duration-300 flex items-center justify-center"
          >
            Browse Rooms
          </Link>
        </div>

        {/* Hamburger Icon for Mobile & Tablet */}
        <div className="lg:hidden h-[36px] top-[20px] left-[16px] md:w-[706px] md:h-[100px] flex justify-end items-center">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="focus:outline-none"
          >
            <img
              src={
                isOpen
                  ? "/images/icon/close.svg"
                  : isWhiteTextPage
                  ? "/images/icon/menu_white.svg"
                  : "/images/icon/menu_black.svg"
              }
              alt={isOpen ? "Close" : "Open"}
              className="w-[36px] h-[36px]"
            />
          </button>
        </div>
      </div>

      {/* Fullscreen Overlay Menu for Mobile & Tablet */}
      {isOpen && (
        <div className="fixed top-0 left-0 w-full h-screen bg-white z-40 px-4 pt-6 overflow-y-auto overflow-x-hidden lg:hidden font-lora">
          <div className="flex justify-end mb-4">
            <button
              onClick={() => setIsOpen(false)}
              className="text-black"
            >
              <img
                src="/images/icon/close.svg"
                alt="Close menu"
                className="w-[36px] h-[36px] md:w-[40px]"
              />
            </button>
          </div>

          <div className="flex flex-col items-start space-y-4">
            <Link to="/" className="text-black flex flex-row items-center">
              <img src="/Asset-2.png" alt="Znorm Homes Logo" className="w-[55px] h-[55px] md:w-[65px] md:h-[65px] lg:w-[80px] lg:h-[80px] mr-6 object-contain" />
              <div>
                <span className="outfit-title">ZNORM </span>
                <span className="lg:text-[30px] md:text-[24px] text-[20px] font-light">HOMES</span>
              </div>
            </Link>

            <Link
              to="/"
              className="md:w-[300px] w-[361px] h-[44px] bg-[#87A768] hover:brightness-105 text-white text-[12px] md:text-[14px] lg:text-[16px] font-outfit transition duration-300 flex items-center justify-center"
            >
              Browse Rooms
            </Link>

            <div className="border-t-[0.5px] border-[#D6D6D6] border-opacity-50 w-full md:w-[706px] my-4" />

            <Link to="/" onClick={() => setIsOpen(false)} className="text-black text-[14px] font-outfit hover:text-gray-200">Home</Link>
            <Link to="/aboutus" onClick={() => setIsOpen(false)} className="text-black text-[14px] font-outfit hover:text-gray-200">About</Link>
            <Link to="/services" onClick={() => setIsOpen(false)} className="text-black text-[14px] font-outfit hover:text-gray-200">Amenities</Link>
            <Link to="/#gallery" onClick={() => setIsOpen(false)} className="text-black text-[14px] font-outfit hover:text-gray-200">Gallery</Link>
            <div className="border-t-[0.5px] border-[#D6D6D6] border-opacity-50 w-full md:w-[706px] my-2" />
            <Link to="/contact" onClick={() => setIsOpen(false)} className="text-black text-[14px] font-outfit hover:text-gray-200">Contact</Link>
            <Link to="/partnership" onClick={() => setIsOpen(false)} className="text-black text-[14px] font-outfit hover:text-gray-200">Partner with us</Link>
            <div className="border-t-[0.5px] border-[#D6D6D6] border-opacity-50 w-full md:w-[706px] my-2" />
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
